import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ExerciseInstructions = ({ exercise }) => {
  const [showAlternatives, setShowAlternatives] = useState(false);

  return (
    <div className="bg-card border border-border rounded-lg shadow-md overflow-hidden">
      <div className="aspect-video bg-muted relative overflow-hidden">
        <Image
          src={exercise?.demonstrationImage}
          alt={exercise?.demonstrationImageAlt}
          className="w-full h-full object-cover"
        />
        <button
          className="absolute inset-0 flex items-center justify-center bg-background/40 backdrop-blur-sm hover:bg-background/50 transition-smooth"
          aria-label="Play demonstration video"
        >
          <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-accent flex items-center justify-center shadow-xl hover-lift press-scale">
            <Icon name="Play" size={32} color="var(--color-accent-foreground)" strokeWidth={2.5} />
          </div>
        </button>
      </div>
      <div className="p-4 md:p-6">
        <div className="flex items-start justify-between mb-4">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-1">
              {exercise?.name}
            </h2>
            <div className="flex flex-wrap items-center gap-2 text-sm text-muted-foreground">
              <span className="flex items-center gap-1">
                <Icon name="Target" size={16} />
                {exercise?.targetMuscle}
              </span>
              <span>•</span>
              <span className="flex items-center gap-1">
                <Icon name="Zap" size={16} />
                {exercise?.difficulty}
              </span>
            </div>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setShowAlternatives(!showAlternatives)}
            aria-label="Show alternative exercises"
          >
            <Icon name="RefreshCw" size={20} />
          </Button>
        </div>

        <div className="space-y-4">
          <div>
            <h3 className="text-sm font-heading font-semibold text-foreground mb-2 flex items-center gap-2">
              <Icon name="ListOrdered" size={16} color="var(--color-primary)" />
              Instructions
            </h3>
            <ol className="space-y-2">
              {exercise?.instructions?.map((instruction, index) => (
                <li key={index} className="flex gap-3 text-sm text-foreground">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 text-primary flex items-center justify-center text-xs font-bold data-text">
                    {index + 1}
                  </span>
                  <span className="flex-1">{instruction}</span>
                </li>
              ))}
            </ol>
          </div>

          <div className="p-3 bg-warning/10 border border-warning/20 rounded-lg">
            <h4 className="text-sm font-heading font-semibold text-warning-foreground mb-1 flex items-center gap-2">
              <Icon name="AlertTriangle" size={16} color="var(--color-warning)" />
              Form Tips
            </h4>
            <ul className="space-y-1">
              {exercise?.formTips?.map((tip, index) => (
                <li key={index} className="text-xs text-foreground flex items-start gap-2">
                  <Icon name="Check" size={14} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
                  <span>{tip}</span>
                </li>
              ))}
            </ul>
          </div>

          {showAlternatives && exercise?.alternatives && (
            <div className="p-3 bg-muted rounded-lg">
              <h4 className="text-sm font-heading font-semibold text-foreground mb-2">
                Alternative Exercises
              </h4>
              <div className="space-y-2">
                {exercise?.alternatives?.map((alt, index) => (
                  <button
                    key={index}
                    className="w-full text-left p-2 rounded hover:bg-background transition-smooth"
                  >
                    <p className="text-sm font-medium text-foreground">{alt?.name}</p>
                    <p className="text-xs caption text-muted-foreground">{alt?.reason}</p>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExerciseInstructions;